export default __webpack_public_path__ + "static/media/instagram-gold.1d0b604f.png";